import gql from "graphql-tag";

export const MY_TAX_GET_FOUR_CHILDREN_DECLARATION = gql`
  query taxDeclarationFourChildren($_id: Int!) {
    taxDeclarationFourChildren(_id: $_id) {
      dateOfDeclaration
      isModifiedDeclaration
      state
      isEligible
      permanentlyEntitled
      notApplyFromMonth
      dependents {
        dependentSerialNumber
        name
        taxNumber
        placeOfBirth
        dateOfBirth
        mothersName
      }
    }
  }
`;
